export enum ProjectFreelancerProfileStatus {
  NotSubmitted = 'NotSubmitted',
  SubmittedCSM = 'SubmittedCSM',
  InDiscussion = 'InDiscussion',
  Revised = 'Revised',
  CastingScheduled = 'CastingScheduled',
  Accepted = 'Accepted',
  RefusedClient = 'RefusedClient',
  RefusedTalent = 'RefusedTalent',
  SubmittedClient = 'SubmittedClient',
  Cancelled = 'Cancelled',
}